
import { productStatus } from "@/config";
import { translateLanguage } from "@/helper/i18n";
import { useTranslation } from "react-i18next";
import { TbMessage2 } from "react-icons/tb";

interface AddOnItemProps {
    _id: string;
    name: string;
    nameKH?: string;
    price: number;
    qty: number;
    note: string;
    status: number
}

export default function AddOnItem({ _id, name, nameKH, price, qty, note, status }: AddOnItemProps) {
    const { t } = useTranslation();

    return (
        <div className="pt-4">
            <div className="flex flex-col gap-2 px-2">
                <div className="flex justify-between pl-6">
                    <h1 className="text-total text-[#292B2C]">{translateLanguage(name, nameKH ? nameKH : name)}</h1>
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex justify-between items-center pl-6">
                        <h1 className="text-total text-danger">${price}</h1>
                        <p
                            className={`
                                text-status py-2 px-4 rounded-[6px] 
                                ${status === productStatus.Pending ? "bg-[#E19D0F]/10 text-[#E19D0F]" : ""}
                                ${status === productStatus.Accept ? "bg-[#527FDF]/10 text-[#527FDF]" : ""}
                                ${status === productStatus.Accept ? "bg-danger/10 text-danger" : ""}
                                ${status === productStatus.Process ? "bg-[#F1EDFF] text-[#6352A2]" : ""}
                                ${status === productStatus.Ready ? "bg-[#41AE5E]/10 text-[#41AE5E]" : ""}
                                ${status === productStatus.Completed ? "bg-[#64748B]/10 text-[#64748B]" : ""}
                            `}
                        >
                            {status === productStatus.Pending && t('pending')}
                            {status === productStatus.Accept && t('accepted')}
                            {status === productStatus.Reject && t('reject')}
                            {status === productStatus.Process && t('cooking')}
                            {status === productStatus.Ready && t('ready')}
                            {status === productStatus.Completed && t('completed')}
                        </p>
                    </div>
                    <div className="flex items-center gap-1">
                        <input
                            className='mr-1 cursor-pointer w-5 h-5 rounded-[4px] text-primary border-[#C1C1C1]/30 focus:outline-none focus:ring-0'
                            type="checkbox"
                            id={`check-${_id}`}
                            disabled
                            readOnly
                        />
                        <p className="w-full border-t-[1px] border-dashed border-[#EAEAEA]"></p>
                    </div>
                    <div className="flex justify-between items-center pl-6">
                        <p className="text-[#202020] text-total py-2">
                            X <span className="text-primary">{qty}</span>
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2 pl-6">
                    <TbMessage2 size={24} className="text-[#767676]" />
                    <input
                        readOnly
                        type="text"
                        value={note}
                        placeholder="Add notes..."
                        className="w-full text-subtotal text-[#383838] placeholder:text-[#B6B6B6] p-0 focus:ring-0 focus:outline-none border-none"
                    />
                </div>
            </div>
            <hr color="#ECE7E7" className="my-4" />
        </div>
    )
}
